module.exports = function () {
    ICF.Utils.EqualHeights.RegisterSetEqualHeights(".blog-data-table-header-row", 0);
    ICF.Utils.EqualHeights.RegisterSetEqualHeights(".blog-data-table-body-row", 0);
    ICF.Utils.EqualHeights.RegisterSetEqualHeights(".blog-data-table-footer-row", 0);
}